











































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Issue, IssueConst} from '../../models/Issue'
import Helper from '../../services/Helper.js'

@Component({
  components: {},
})
export default class IssueRow extends Vue {
  @Prop() issue: Issue
  @Prop() currentIndex: number

  IssueConst = IssueConst

  number_format(number) {
    return Helper.number_format(Math.round(number))
  }

  map(status) {
    return IssueConst.map(status)
  }

  getStatusColor(status) {
    return IssueConst.color(status)
  }

  //          {{ issue.status>=IssueConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO?$helper.date_format_short(issue.erp_so_at):$helper.date_format_short(issue.submitted_at)}}

  openIssue(option) {
    this.$root.$emit('openIssue', option)
  }
}

